import Http from "../commons/utils/Http";
import {errorHandling} from "../commons/utils/error";

class modulesService {

    async getAll(page) {
        try {
            let response = await Http.get(`/modules/get-all?offset=${page}`,Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async getId(id) {
        try {
            let response = await Http.get(`/modules/get-by?field=id&value=${id}`,Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async search(search) {
        try {
            let response = await Http.get(`/modules/search?search=${search}`,Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async insert(data) {
        try {
            let response = await Http.post(`/modules`, data,Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async update(data) {
        try {
            let response = await Http.put(`/modules`, data,Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async delete(id) {
        try {
            let response = await Http.delete(`/modules/${id}`,Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async saveModuleFunctions(data) {
        try {
            let response = await Http.post(`/modules/save-module-functions`, data,Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async getModules(page) {
        try {
            let response = await Http.get(`/modules/get-modules`,Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async getModulesByRole(id) {
        try {
            let response = await Http.get(`/modules/get-modules-by-role?id=${id}`,Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async getModulesPermissionsByUser(userId) {
        try {
            let response = await Http.get(`/users/get-module?app_id=2&user_id=${userId}`,Http.headers)
            return response.data.data
        } catch (e) {
            errorHandling(e)
        }
    }

}

export default new modulesService();